/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_MeteringInputs */

const en_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metering`)
};

const ar_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قياس الاستخدام`)
};

const bn_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মিটারিং`)
};

const de_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messung`)
};

const es_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medición`)
};

const fr_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptage`)
};

const pt_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medição`)
};

const zh_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计量`)
};

const tr_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ölçüm`)
};

const ru_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Измерение`)
};

const pl_svchip_metering = /** @type {(inputs: Svchip_MeteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomiar`)
};

/**
* | output |
* | --- |
* | "Metering" |
*
* @param {Svchip_MeteringInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_metering = /** @type {((inputs?: Svchip_MeteringInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_MeteringInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_metering(inputs)
	if (locale === "bn") return bn_svchip_metering(inputs)
	if (locale === "de") return de_svchip_metering(inputs)
	if (locale === "es") return es_svchip_metering(inputs)
	if (locale === "fr") return fr_svchip_metering(inputs)
	if (locale === "pt") return pt_svchip_metering(inputs)
	if (locale === "zh") return zh_svchip_metering(inputs)
	if (locale === "tr") return tr_svchip_metering(inputs)
	if (locale === "ru") return ru_svchip_metering(inputs)
	if (locale === "pl") return pl_svchip_metering(inputs)
	return en_svchip_metering(inputs)
});